import type { LogoutButtonProps, UserInitialsProps } from '@/components/UserCard.types';
import { LogOut } from 'lucide-react';

export const LOGOUT_LABEL = 'Skrá út';

export const UserInitials = ({ user }: UserInitialsProps) => (
  <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/20 font-bold text-primary text-xs">
    {user?.initials ||
      user?.name
        ?.split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase() ||
      'U'}
  </div>
);

export const LogoutButton = ({ onLogout }: LogoutButtonProps) => (
  <button
    type="button"
    onClick={onLogout}
    aria-label={LOGOUT_LABEL}
    title={LOGOUT_LABEL}
    className="inline-flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
  >
    <LogOut className="h-4 w-4" />
  </button>
);
